// SAB-522: /privacy — previously blank-redirected to Termly (window.location =
// external URL, rendered null). Now a real in-app page with the canonical
// Termly-hosted policy embedded/linked.
//
// SAB-767: the Aeropay Privacy section was REMOVED, for the same reason as /terms —
// it satisfied Aeropay Integration Agreement Section 6, and Aeropay is not our
// processor. See TermsPage for the full rationale.
//
// NOT COVERED HERE: whether the Termly-hosted Privacy Policy itself names Aeropay.
// That content lives in Termly, not this repo.
import LegalPageShell, { TERMLY_POLICIES } from './LegalPageShell';

export default function PrivacyPage() {
  return <LegalPageShell title="Privacy Policy" termlyUrl={TERMLY_POLICIES.privacy} />;
}
